export default __webpack_public_path__ + "assets/faa055bc9e4ac34235c485f96745d6e5.jpg";